import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { KrampSpecial } from './kramp-special';

@Injectable({
  providedIn: 'root',
})
export class KrampSpecialsService {
  readonly serviceURL: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/specials';
  }

  createKrampSpecial(krampSpecial: KrampSpecial): Observable<KrampSpecial> {
    return this.http.post<KrampSpecial>(this.serviceURL + '/kramp', krampSpecial);
  }

  getKrampSpecial(id: number): Observable<KrampSpecial> {
    return this.http.get<KrampSpecial>(`${this.serviceURL}/kramp/${id.toString()}`);
  }

  getKrampSpecials(): Observable<KrampSpecial[]> {
    return this.http.get<KrampSpecial[]>(this.serviceURL + '/kramp');
  }
}
